import React, { useEffect, useRef, useState } from "react";
import NotificacionAuth from "../NotificacionAuth/NotificacionAuth";
import { useNavigate, useSearchParams } from "react-router-dom";
import useTokenValidation from "../../hooks/useTokenValidation";
import InptContraseña from "../InptContraseña/InptContraseña";
import NotificacionEntity from "../../core/entities/notificacionEntity";
import { ThreeDots } from "react-loader-spinner";
import CambiarContraseñaEntity from "../../core/entities/cambiarContraseñaEntity";
import { cambiarContraseñaTemporal } from "./services/uModalCambiarContraseñaTemporalService";

export default function UModalCambiarContraseñaTemporal({
  vIsCambioContraseñaTemporal = false,
  mActivar_DesactivarModal = () => {},
}) {
  const { tokenEntity, resetearToken, errores, notificacionRef } =
    useTokenValidation();
  const vNavigate = useNavigate();
  let [searchParams] = useSearchParams();
  const [contraseñas, setContraseñas] = useState(new CambiarContraseñaEntity());
  const [vIsCargandoResp, setvIsCargandoResp] = useState(false); // Estado para manejar la animación de carga
  const contraseñaRef = useRef(null);
  const contraseñaRepetirRef = useRef(null);

  const handleInpPass = (evt) => {
    console.log("pass", evt.target.value.trim());
    setContraseñas(
      new CambiarContraseñaEntity(
        localStorage.getItem("password_old"),
        evt.target.value.trim(),
        contraseñas.password_nueva_repetida
      )
    );
  };

  const handleInpPassConfirm = (evt) => {
    console.log(evt.target.value.trim());
    setContraseñas(
      new CambiarContraseñaEntity(
        localStorage.getItem("password_old"),
        contraseñas.password_nueva,
        evt.target.value.trim()
      )
    );
  };

  // ------------------------------------------------------------------
  //                    MÉTODO DE ENVÍO DEL FORMULARIO
  // ------------------------------------------------------------------
  /**
   * Maneja el envío del formulario de cambio de contraseña temporal.
   *
   * Valida las contraseñas ingresadas, envía la solicitud de cambio de
   * contraseña al backend, y maneja las respuestas y notificaciones
   * según el resultado.
   *
   * @param {Event} event - El evento de envío del formulario.
   */
  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(
      localStorage.getItem("password_old"),
      contraseñaRef.current.value.trim(),
      contraseñaRepetirRef.current.value.trim()
    );
    setContraseñas(
      new CambiarContraseñaEntity(
        localStorage.getItem("password_old"),
        contraseñaRef.current.value.trim(),
        contraseñaRepetirRef.current.value.trim()
      )
    );
    if (!vIsCargandoResp) {
      setvIsCargandoResp(true);
      const errores = contraseñas.validar();

      if (errores.length > 0) {
        notificacionRef.current.show(
          new NotificacionEntity("Error de validación", errores[0], "rojo", 15)
        );
        setvIsCargandoResp(false);
        return;
      }
      notificacionRef.current.hide(); // Ocultar notificaciones previas

      cambiarContraseñaTemporal(tokenEntity.token, contraseñas)
        .then((response) => {
          setvIsCargandoResp(false);

          if (response.ok) {
            return response.json();
          }
          // Manejo de errores específicos basados en el código de estado
          switch (response.status) {
            case 400:
              return response.json().then((result) => {
                switch (result.detail.acción) {
                  case "VERIFICAR_FORMATO":
                    notificacionRef.current.show(
                      new NotificacionEntity(
                        "Error de formato",
                        result.detail.detalle,
                        "rojo",
                        15
                      )
                    );
                    break;
                  case "REINTENTAR":
                    notificacionRef.current.show(
                      new NotificacionEntity(
                        "Error en la solicitud",
                        result.detail.detalle,
                        "amarillo",
                        15
                      )
                    );
                    break;
                  case "VALIDAR_ENTRADA":
                    notificacionRef.current.show(
                      new NotificacionEntity(
                        "Error de validación",
                        result.detail.detalle,
                        "rojo",
                        15
                      )
                    );
                    break;
                  case "GENERAR_NUEVO_TOKEN":
                    notificacionRef.current.show(
                      new NotificacionEntity(
                        "Error con el token",
                        result.detail.detalle,
                        "rojo",
                        15
                      )
                    );
                    break;
                  default:
                    notificacionRef.current.show(
                      new NotificacionEntity(
                        "Error desconocido",
                        "Ocurrió un error inesperado.",
                        "rojo",
                        15
                      )
                    );
                    break;
                }
              });
            case 401:
              return response.json().then((result) => {
                switch (result.detail.acción) {
                  case "GENERAR_NUEVO_TOKEN":
                    notificacionRef.current.show(
                      new NotificacionEntity(
                        "Token inválido o expirado",
                        result.detail.detalle,
                        "rojo",
                        15
                      )
                    );
                    break;
                  default:
                    notificacionRef.current.show(
                      new NotificacionEntity(
                        "Credenciales inválidas",
                        result.detail.detalle,
                        "rojo",
                        15
                      )
                    );
                    break;
                }
              });
            case 500:
              return response.json().then((result) => {
                notificacionRef.current.show(
                  new NotificacionEntity(
                    "Error del servidor",
                    result.detail.detalle,
                    "rojo",
                    15
                  )
                );
              });
            default:
              notificacionRef.current.show(
                new NotificacionEntity(
                  "Error desconocido",
                  "Ocurrió un error inesperado.",
                  "rojo",
                  15
                )
              );
              break;
          }
        })
        .then((result) => {
          if (result !== undefined) {
            switch (result["detail"]["acción"]) {
              case "LOGIN_EXITOSO":
                const { token, user_id } = result["detail"]["datos"];
                localStorage.setItem("token", token);
                localStorage.removeItem("password_old");
                vNavigate("/alumno");
                break;

              default:
                notificacionRef.current.show(
                  new NotificacionEntity(
                    "Error desconocido",
                    "Ocurrió un error inesperado.",
                    "rojo",
                    10
                  )
                );
                break;
            }
          }
        })
        .catch((error) => {
          notificacionRef.current.show(
            new NotificacionEntity(
              "Error de red",
              "No se pudo conectar con el servidor.",
              "rojo",
              15
            )
          );
        });
    }
  };

  if (!vIsCambioContraseñaTemporal) {
    return null;
  }

  return (
    <div class="box-modals-publico">
      <div data-figma-id="970:14180" class="cambio-contrasea">
        <div data-figma-id="970:14103" class="cambio-contra-info-1">
          <div data-figma-id="970:14104" class="cambio-contra-titulos">
            <p data-figma-id="970:14105" class="cambio-contra-titulo-1">
              Ya casi...
            </p>
            <p data-figma-id="970:14106" class="cambio-contra-titulo-2">
              Crea una contraseña segura
            </p>
            <p data-figma-id="970:14107" class="cambio-contra-titulo-3">
              Tu contraseña deberá contener al menos 6 caracteres e incluir
              letras, números y caracteres especiales (!$%@*)
            </p>
          </div>
          <div data-figma-id="970:14109" class="cambio-contra-info">
            <div data-figma-id="970:14110" class="cambio-contra-apartados">
              <InptContraseña
                texto="Nueva Contraseña"
                contraseñaRef={contraseñaRef}
                handleInpPass={handleInpPass}
                onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
              />
              <InptContraseña
                texto="Confirmar Contraseña"
                contraseñaRef={contraseñaRepetirRef}
                handleInpPass={handleInpPassConfirm}
                onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
              />
            </div>
            <div data-figma-id="970:14113" class="cambio-contra-botones">
              <div
                data-figma-id="970:14176"
                class="boton-regresar"
                onClick={() => {
                  vNavigate("/");
                  resetearToken();
                  mActivar_DesactivarModal("", false);
                }}
              >
                <p data-figma-id="970:14177" class="boton-regresar-texto">
                  Regresar al inicio
                </p>
              </div>
              <div
                data-figma-id="970:14178"
                className="boton-cambiar-contra"
                onClick={handleSubmit}
                style={
                  vIsCargandoResp
                    ? { cursor: "wait", backgroundColor: "#1D90F5" }
                    : {}
                }
              >
                {vIsCargandoResp ? (
                  <ThreeDots
                    height="30"
                    width="30"
                    color="#fff"
                    radius="1"
                    ariaLabel="three-dots-loading"
                  />
                ) : (
                  <p
                    data-figma-id="970:14179"
                    class="boton-cambiar-contra-texto"
                  >
                    Cambiar mi contraseña
                  </p>
                )}
              </div>
            </div>
          </div>
          <NotificacionAuth
            ref={notificacionRef} // Usando la referencia
          />
        </div>
        <div data-figma-id="970:14116" class="cambio-contra-info-2">
          <div data-figma-id="970:14117" class="cambio-contra-imagen">
            <div data-figma-id="970:14118" class="cambio-contra-cita">
              <p data-figma-id="970:14119" class="cambio-contra-cita-1">
                “
              </p>
              <p data-figma-id="970:14120" class="cambio-contra-cita-2">
                Una inversión en conocimiento paga el mejor interés
              </p>
              <p data-figma-id="970:14121" class="cambio-contra-cita-3">
                - Benjamin Franklin
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
